import { defineStore } from 'pinia';

export const storeFactory = <T>(name: string) => {
  return defineStore<string, any, any, any>(name, {
    state: () => ({}),
    getters: {},
    actions: {
      set(obj: T): T {
        (this.$state as T) = obj;
        return <T>this.$state;
      },
      get(): T {
        return <T>this.$state;
      },
    },
    persist: {
      storage: persistedState.localStorage,
    },
  });
};
